<template>
  <pt-integral-task-list class="pt-integral-task-list__withData" @getTableData="getTableData" :tableData="tableData" :tableLabel="tableLabel" :totalNumber="totalNumber"
  ref="tableIndex" :isOutside="isOutside">
  <slot/>
  </pt-integral-task-list>
</template>

<script>
import PtIntegralTaskList from './index'
export default {
  name: 'pt-integral-task-list__withData',
  components: {
    'pt-integral-task-list': PtIntegralTaskList
  },
  props: {
    tableLabel: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 99
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  computed: {
    page () {
      return this.$refs.tableIndex.page
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
        //   this.getTableData(0)
          this.$refs.tableIndex.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        levelCode: Number(this.paramsData.levelCode),
        ...this.paramsData.publishTime
      }
      this.$store.dispatch('getIntegralTaskList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        console.log(this.tableData)
        this.$emit('updateSummay', res.pointSummay)
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$refs.tableIndex.showReTry()
        this.$message.error(err || '获取列表失败')
      })
    },
    load () {
      // this.$nextTick(_ => {
      this.$refs.tableIndex.load()
      // })
    }
  }
}
</script>
